import React, { useEffect } from 'react';
import Modal from 'rc-dialog';
import { useLocalStore, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import {
  DialogActionType,
  IModalProps
} from '@app/src/common/store/ModalStore';
import { createStore } from './createStore';

import Logo from '@app/src/assets/icons/logo.svg';
import WindowsIcon from './assets/icon-windows.svg';

import './AboutModal.scss';

const modules = [
  'devices',
  'content',
  'schedule',
  'media',
  'users',
  'check.in',
  'wayfinding'
];

const AboutModal = ({ onClose }: IModalProps) => {
  const store = useLocalStore(createStore);

  const onCancel = () => {
    onClose(DialogActionType.cancel);
  };

  useEffect(() => {
    store.fetchPlayerInfo();
  }, []);

  return (
    <Modal
      onClose={onCancel}
      className="about-modal"
      destroyOnClose={true}
      visible
    >
      <header className="about-modal__header">
        <Logo className="about-modal__logo" />

        <p className="about-modal__version">
          <FormattedMessage id="app.about.version" />

          {store.version && store.version}
        </p>
      </header>

      <h4 className="about-modal__subheader">friendlyway Cloud Platform</h4>

      <p className="about-modal__description">
        <FormattedMessage id="app.about.description" />
      </p>

      <h4 className="about-modal__subheader">
        <FormattedMessage id="app.about.module.title" />
      </h4>

      <ul className="about-modal__features-list">
        {modules.map(module => (
          <li className="about-modal__features-item" key={module}>
            <FormattedMessage id={`app.about.module.${module}`} tagName="b" />

            <FormattedMessage
              id={`app.about.module.${module}.description`}
              tagName={React.Fragment}
            />
          </li>
        ))}
      </ul>

      <p className="about-modal__description about-modal__other">
        <FormattedMessage id="app.about.module.other" />
      </p>

      <h3 className="about-modal__subheading">friendlyway Player</h3>

      <p className="about-modal__description">
        <FormattedMessage id="app.about.player" />
      </p>

      {store.packageRelease ? (
        <div className="about-modal__footer">
          <a
            className="about-modal__footer-download-link"
            href={store.packageRelease.downloadUrl}
            download
          >
            <WindowsIcon className="about-modal__footer-icon" />

            <p className="about-modal__footer-text">
              <FormattedMessage id="app.about.download" />

              <span className="about-modal__footer-package-name">Windows</span>
            </p>
          </a>
          <p className="about-modal__footer-version">
            <FormattedMessage id="app.about.version" />

            {store.packageRelease.version}
          </p>
        </div>
      ) : (
        <div className="about-modal__footer-gag" />
      )}
    </Modal>
  );
};

export default observer(AboutModal);
